// Cross-origin link helpers for the marketing site. The app lives on a
// different origin (default `https://app.planamoto.com`), so any internal
// link that points into the app must use a full URL.
//
// The origin is configured at build time via REACT_APP_APP_ORIGIN. In dev
// it defaults to http://localhost:3000 so the two CRA dev servers can
// talk to each other without ceremony.

const fallbackOrigin =
    process.env.NODE_ENV === "production"
        ? "https://app.planamoto.com"
        : "http://localhost:3000";

const APP_ORIGIN: string =
    (process.env.REACT_APP_APP_ORIGIN || "").trim() || fallbackOrigin;

export const appUrl = (path: string = "/"): string => {
    if (!path.startsWith("/")) path = `/${path}`;
    return `${APP_ORIGIN.replace(/\/$/, "")}${path}`;
};

export const goToApp = (path: string = "/"): void => {
    window.location.assign(appUrl(path));
};
